define.alias("ember-math-helpers/helpers/min", "calendar/helpers/min");